export const APP_ROOT_API = process.env.VUE_APP_ROOT_API;
export const APP_ROOT_DOMAIN = process.env.VUE_APP_ROOT_DOMAIN;
